import { DashboardEffect } from "@store/dashboard/dashboard.effect";
import {
  dashboardReducer,
  DashboardState,
} from '@store/dashboard/dashboard.reducer';
import { NotificationDetailEffect } from "@store/notification-detail/notification-detail.effect";
import {
  notificationDetailReducer,
  NotificationDetailState
} from "@store/notification-detail/notification-detail.reducer";
import { NotificationListEmailSmsEffect } from "@store/notification-list-email-sms/notification-list-email-sms.effect";
import { notificationListEmailSmsReducer, NotificationListEmailSmsState } from "@store/notification-list-email-sms/notification-list-email-sms.reducer";
import { NotificationListTeamsEffect } from "@store/notification-list-teams/notification-list-teams.effect";
import { notificationListTeamsReducer, NotificationListTeamsState } from "@store/notification-list-teams/notification-list-teams.reducer";
import { UserInfosEffect } from "@store/user-infos/user-infos.effect";
import { userInfosReducer, UserInfosState } from "@store/user-infos/user-infos.reducer";
import { CampaignEffect } from "./campaign/campaign.effect";
import { campaignReducer, CampaignState } from "./campaign/campaign.reducer";
import { ProductsEffect } from "./products/products.effect";
import { productsReducer, ProductsState } from "./products/products.reducer";
import { ThresholdsListEffect } from "./thresholds-list/thresholds-list.effect";
import { thresholdsListReducer, ThresholdsListState } from "./thresholds-list/thresholds-list.reducer";
import { uiReducer, UiState } from "./ui/ui.reducer";

export interface State {
  notificationListEmailSms: NotificationListEmailSmsState;
  notificationListTeams: NotificationListTeamsState;
  notificationDetail: NotificationDetailState;
  thresholdsList: ThresholdsListState;
  dashboard: DashboardState;
  userInfos: UserInfosState;
  campaign: CampaignState;
  products: ProductsState;
  ui: UiState;
}

export const reducers = {
  notificationListEmailSms: notificationListEmailSmsReducer,
  notificationListTeams: notificationListTeamsReducer,
  notificationDetail: notificationDetailReducer,
  thresholdsList: thresholdsListReducer,
  dashboard: dashboardReducer,
  userInfos: userInfosReducer,
  campaign: campaignReducer,
  products: productsReducer,
  ui: uiReducer,
};

export const effects = [
  NotificationListEmailSmsEffect,
  NotificationListTeamsEffect,
  NotificationDetailEffect,
  ThresholdsListEffect,
  DashboardEffect,
  UserInfosEffect,
  CampaignEffect,
  ProductsEffect,
]

export const runtimeChecks = {
  // Default On:
  strictStateImmutability: true, //  verifies that the state isn't mutated.
  strictActionImmutability: true, //  verifies that actions aren't mutated
  // Default Off:
  strictStateSerializability: true, // verifies if the state is serializable
  strictActionSerializability: true, // verifies if the actions are serializable
  strictActionWithinNgZone: true, // verifies if actions are dispatched within NgZone
  strictActionTypeUniqueness: true, // verifies if registered action types are unique
};
